import React from "react";

function Consorcio() {
  return (
    <div className="home">
      <iframe
        title="Cobrança"
        class="video"
        widht="100%"
        height="100%"
        src="https://app.powerbi.com/reportEmbed?reportId=a63798b2-0bc1-4f47-8d69-871ad579250d&autoAuth=true&ctid=f88c7305-11d1-4b34-a8a0-da6536019e31"
        marginheight="0"
        marginwidth="0"
        scrolling="0"
        frameborder="0"
        allowFullScreen="true"
      ></iframe>
    </div>
  );
}

export default Consorcio;
